const animateElement = document.querySelectorAll(".animate");

const observeAnimate = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (entry.target.classList.contains("toggle")) {
      if (entry.isIntersecting) {
        entry.target.classList.add("animated");
      } else {
        entry.target.classList.remove("animated");
      }
    } else {
      if (entry.isIntersecting) {
        entry.target.classList.add("animated");
        observer.unobserve(entry.target);
      }
    }
  });
}, {
  threshold: 0.6
});

animateElement.forEach(el => observeAnimate.observe(el));